import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Router } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { concatMap, switchMap } from 'rxjs/operators';
import * as AuthActions from './auth.actions';

@Injectable()
export class AuthEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);

  loadAuths$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.loadAuths),
      /** An EMPTY observable only emits completion. Replace with your own observable API request */
      concatMap(() => EMPTY as Observable<{ type: string }>),
    );
  });

  resetAuth$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.resetAuth),
      switchMap(({ returnUrl }) => {
        // docs/e2e-backlog.md#bug-026 - a signed-out visit to any /auth/*
        // route other than login used to get bounced back to /auth/login by
        // this navigate firing unconditionally on every boot
        // (CommonAppComponent.ngOnInit dispatches resetAuth() once Firebase
        // resolves an absent session, always after the initial route has
        // rendered). Only navigate when the current route actually requires
        // a session.
        if (this.router.url.startsWith('/auth/')) {
          return EMPTY;
        }
        // docs/e2e-backlog.md#bug-025 - this is the navigation that actually
        // reaches /auth/login (AuthGuard.canActivate dispatches resetAuth()
        // before it would otherwise redirect itself, and that dispatch
        // reentrantly cancels the guard's own in-flight navigation - see the
        // entry's traced root cause). Carrying returnUrl on the action is
        // what lets it survive: a query param on this navigation, rather than
        // a separate NgRx round-trip that raced it.
        return this.router.navigate(
          ['/auth/login'],
          returnUrl ? { queryParams: { returnUrl } } : {},
        );
      }),
      /** An EMPTY observable only emits completion. Replace with your own observable API request */
      concatMap(() => EMPTY as Observable<{ type: string }>),
    );
  });
}
